import { useEffect, useState } from "react";
import classes from "./ContactDetails.module.scss"
import EditableRow from "../../../../../components/EditableRow/EditableRow";
import { UserService } from "../../../../../services/UserService";
import { useLoader } from "../../../../../customHooks/loader";
import { globalErrorHandler } from "../../../../../utils/errorHandler";

// {
//     name: "Albin Nikolovski",
//     email: "alb@gmail.com",
//     phone: 8908908908,
//     password: "*****",
//     addresses: [
//         {
//             defaultShippingAddress: true,
//             defaultBillingAddress: false,
//             firstName: "Albin",
//             lastName: "Nikolovski",
//             phone: 8908908908,
//             postalCode: 110049,
//             city: "delhi",
//             state: "delhi",
//             streetAddress: "342/3, me home",
//             addressType: "Home",
//         },
//         {
//             defaultShippingAddress: false,
//             defaultBillingAddress: false,
//             firstName: "Albin",
//             lastName: "Nikolovski",
//             phone: 8908908908,
//             postalCode: 110049,
//             city: "delhi",
//             state: "delhi",
//             streetAddress: "342/3, me home",
//             addressType: "Office",
//         },
//         {
//             defaultShippingAddress: true,
//             defaultBillingAddress: true,
//             firstName: "Albin",
//             lastName: "Nikolovski",
//             phone: 8908908908,
//             postalCode: 110049,
//             city: "delhi",
//             state: "delhi",
//             streetAddress: "342/3, me home",
//             addressType: "Home 2",
//         },
//     ]
// }

export default function ContactDetails({ setAddAddress }) {
    const loader = useLoader();
    const [contactDetails, setContactDetails] = useState({});

    useEffect(() => {
        getUserDetails();
    }, [])

    const handleGetUserDetailsSuccess = ({ data }) => {
        console.log(data.data);
        setContactDetails(data.data.userData);
    }

    const getUserDetails = () => {
        UserService.getUserDetails(
            handleGetUserDetailsSuccess,
            globalErrorHandler,
            loader
        );
    }

    return (
        contactDetails?.id ? <div>
            <div className={classes.ContactDetails}>
                <div className={classes.Heading}>Contact Details</div>
                <EditableRow label="Name" queryKey="fullName" initialValue={contactDetails.fullName} />
                <EditableRow label="Email Address" initialValue={contactDetails.email} disableEditting />
                <EditableRow label="Phone Number" queryKey="mobile" initialValue={contactDetails.mobile} />
                <EditableRow label="Password" queryKey="password" initialValue="****" />
            </div>
            <div className={classes.Address}>
                <div className={classes.HeadingWithButton}>
                    <div className={classes.Heading}>Address</div>
                    <div className={classes.HeadingActionButton} onClick={() => setAddAddress(true)}>Add New</div>
                </div>
                <div className={classes.AddressDisplayContainer}>
                    {contactDetails.addresses.map((item) => (
                        <div className={classes.AddressDisplay}>
                            <div className={classes.AddressDisplayName}>{item.firstName + ' ' + item.lastName}</div>
                            <div className={classes.AddressDisplayDetails}>
                                {item.phone} <br />
                                {item.streetAddress}, {item.city}, {item.state}, {item.postalCode}
                            </div>
                            <div className={classes.AddressDisplayTags}>
                                {item.addressType && <div className={classes.AddressDisplayTag}>{item.addressType}</div>}
                                {item.isDefaultShippingAddress && <div className={classes.AddressDisplayTag}>Default Shipping Address</div>}
                                {item.isDefaultBillingAddress && <div className={classes.AddressDisplayTag}>Default Billing Address</div>}
                            </div>
                            <div className={classes.AddressEditActions}>
                                <div className={classes.AddressRemove}>Remove</div>
                                <div onClick={() => setAddAddress(item)}>Edit</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div> : <></>
    )
}
